'use strict';
const _ = require("lodash"),
    $ = require("jquery"),
    Backbone = require("backbone")
    ;

module.exports = Backbone.Model.extend({
    defaults: {
        copy: {},
        uid: null,
        share: {},
        native: false
    },
    /**
     * [initialize description]
     * @param  {[type]} attrs   [description]
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    initialize: function (attrs, options) {

    },
    /**
    *
    */
    fetch: function(options) {
        console.log('Share model does not support "fetch"');
    },
    /**
    *
    */
    save: function(attrs, options) {
        console.log('Share model does not support "save"');
    },
    /**
    *
    */
    destroy: function(options) {
        options = options ? _.clone(options) : {};
        var model = this;
        var wait = options.wait;

        var destroy = function() {
          model.stopListening();
          model.trigger('destroy', model, model.collection, options);
        };

        if (!wait) destroy();

        console.log('Share model does not support "destroy"');
    }
});


// WEBPACK FOOTER //
// ./app/scripts/models/share.js